module.exports = __webpack_public_path__ + "img/amazon-pay.a96f9882.png";